<script setup lang="ts">
import type { ProductLine } from '~/types/api'

const props = defineProps<{
  line: ProductLine
}>()

const itemsPerPage = ref(4)
const page = ref(1)
const productLineRepository = createProductLineRepository()

const { data: newsList, error } = await useLazyAsyncData(
  () =>
    productLineRepository.getAllNewsPagination(
      page.value,
      itemsPerPage.value,
      props.line.nid
    ),
  {
    watch: [page, itemsPerPage],
    default: defaultPaginationObject,
  }
)

const toast = useToast()

watch(
  () => error,
  () => {
    if (import.meta.client && error.value) {
      toast.add({
        title: error.value.message,
        color: 'red',
      })
    }
  },
  { immediate: true }
)

const newsElement = ref<HTMLElement | null>()
</script>

<template>
  <UiSection
    ref="newsElement"
    :title="$t('productline.latestMentions.title')"
    v-if="newsList.items.length"
  >
    <div class="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
      <NewsCard
        v-for="news in newsList.items"
        variant="light"
        :show-perex="false"
        :key="news.nid"
        class="!w-full"
        :news="news"
      />
      <!-- TODO: Add button to show all mentions -->
    </div>
  </UiSection>
</template>
